import PublicLayout from "./PublicLayout/PublicLayout.svelte";
import LoginComponent from "./Login/Login.svelte";
import TableroComponent from "./PublicLayout/Tablero/Tablero.svelte";
import AlumnosComponent from "./Alumnos/Alumnos.svelte";
import AlumnosAgregarComponent from "./Alumnos/AlumnoAgregar/AlumnoAgregar.svelte";
import AlumnoComponent from "./Alumno/Alumno.svelte";
import ConfiguracionComponent from "./Configuracion/Configuracion.svelte";

const tokenEstablecido = () => {
    const token = localStorage.getItem("token");
    return token !== "" && token !== null;
}

export const routes = [
    {
        name: "/",
        component: TableroComponent,
        layout: PublicLayout,
        onlyIf: {
            guard: tokenEstablecido,
            redirect: '/login'
        }
    },
    {
        name: "login",
        component: LoginComponent
    },
    {
        name: "alumnos",
        component: AlumnosComponent,
        layout: PublicLayout,
        onlyIf: {
            guard: tokenEstablecido,
            redirect: '/login'
        },
        nestedRoutes: [
            {
                name: 'agregarAlumno',
                component: AlumnosAgregarComponent
            }
        ]
    },
    {
        name: "alumno/:id",
        component: AlumnoComponent,
        layout: PublicLayout,
        onlyIf: {
            guard: tokenEstablecido,
            redirect: '/login'
        }
    },
    {
        name: "configuracion",
        component: ConfiguracionComponent,
        layout: PublicLayout,
        onlyIf: {
            guard: tokenEstablecido,
            redirect: '/login'
        }
    }
];